import { INTERACTIVE_SLIDE_NAMES } from '@/constant/slideTypes'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'

const SET_PROMPT_SUGGESTIONS = 'SET_PROMPT_SUGGESTIONS'

const _state = {
  promptSuggestions: [],
}

const _getters = {
  promptSuggestions: (state) => state.promptSuggestions,
}

const actions = {
  getPromptSuggestionsAction({ commit, rootState }) {
    const userCountry = rootState.currentUser.country ? rootState.currentUser.country : 'Singapore'
    const userCity = rootState.currentUser.city ? rootState.currentUser.city : 'Paris'
    const interactiveSlide = OpenAIUtils.getRandomItemsInArray(INTERACTIVE_SLIDE_NAMES, 1)

    const allExamples = [
      'Funny icebreaker questions',
      `12 slides presentation about ${userCity}`,
      'Create a presentation using my company Leave Policy',
      `2 ${interactiveSlide} slides about ${userCountry}`,
    ]

    commit(SET_PROMPT_SUGGESTIONS, allExamples)
  },
}

const mutations = {
  [SET_PROMPT_SUGGESTIONS](state, value) {
    state.promptSuggestions = value
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
